<div class="d-flex flex-column status-toggle">
    <mat-slide-toggle [checked]="getStateService().upcoming" (change)="onUpcomingToggle($event)">Upcoming</mat-slide-toggle>
</div>
<div class="d-flex flex-column status-toggle">
    <mat-slide-toggle [checked]="getStateService().isHome" (change)="onInHomeToggle($event)">In Home</mat-slide-toggle>
</div>
<div class="d-flex flex-column status-toggle">
    <mat-slide-toggle [checked]="getStateService().completed" (change)="onCompletedToggle($event)">Completed</mat-slide-toggle>
</div>
<div class="d-flex flex-column status-toggle">
    <mat-slide-toggle [checked]="getStateService().canceled" (change)="onCanceledToggle($event)">Canceled</mat-slide-toggle>
</div>
<div class="d-flex flex-column status-toggle">
    <mat-slide-toggle [checked]="getStateService().claimFiled" (change)="onClaimFiledToggle($event)">Claim Filed</mat-slide-toggle>
</div>

<ng-container *ngIf="getStateService().allStatusFiltersDisabled()">
    <div class="mt-2">
        <span style="color: red">*</span>&nbsp;<span class="text-muted">All filters inactive, <br />no reservations will be displayed</span>
    </div>
</ng-container>